export default __webpack_public_path__ + "b60ed92a986abfff06944f449e7bd5e6.png";